import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const hospitalityImage = "https://images.pexels.com/photos/33908897/pexels-photo-33908897.jpeg?auto=compress&cs=tinysrgb&w=1200&h=900";

const visionPoints = [
'Self-sustaining neighbourhoods',
'Premium hospitality experiences',
'Intelligent residential communities',
'A new standard for integrated living'];


export const Vision = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="vision"
      data-testid="vision-section"
      ref={ref}
      className="py-24 lg:py-32 bg-[#EFEBE4]">

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          {/* Image */}
          <motion.div
            className="image-zoom order-2 lg:order-1"
            initial={{ opacity: 0, x: -30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}>

            <img
              src={hospitalityImage}
              alt="Hemraj Vision"
              className="w-full aspect-[4/3] object-cover" />

          </motion.div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <motion.p
              className="overline mb-4"
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6 }}>

              The Vision
            </motion.p>

            <motion.h2
              data-testid="vision-title"
              className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#1A1A1A] leading-[1.2]"
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.1 }}>

              Building for Generations
            </motion.h2>

            <div className="gold-line mt-6 mb-8" />

            <motion.p
              className="text-base text-[#4A4A4A] leading-relaxed mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 }}>

              Hemraj Grandsons is not just building projects. It is building an interconnected 
              ecosystem where land, architecture, materials, technology, operations, hospitality, 
              fashion, and culture work together under one umbrella.
            </motion.p>

            <motion.div
              className="space-y-4 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.3 }}>

              {visionPoints.map((point, index) =>
              <div key={point} className="flex items-center gap-4">
                  <span className="text-[#C5A880] font-heading text-lg">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="text-[#1A1A1A] font-light">{point}</span>
                </div>
              )}
            </motion.div>

            <motion.div
              className="bg-[#1A1A1A] p-8 lg:p-10"
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.4 }}>

              <p className="font-heading text-xl lg:text-2xl font-light text-[#F9F6F0] italic leading-relaxed">"Hemraj Grandsons is not simply a company. It is a house that builds homes, experiences, and identities for generations."


              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>);

};